import React, { useState } from 'react'

import { Button } from '@chakra-ui/react'
import { useAtomValue } from 'jotai'
import { Dictionary } from 'lodash'
import { useParams } from 'react-router'
import { useCloseModalByDeps } from 'src/hooks/use-close-modal-by-deps'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { ReleaseTemplateModal } from './modal'
import { trialIdParamName } from '../../../../trial-detail'
import { useTemplateEntities } from '../../../template-entities-context'
import { templateDetailAtom } from '../atom'
import { templateIdParamName } from '../template-detail'

type Props = {
  onValidate: () => Dictionary<Dictionary<boolean>>
  disabled: boolean
}

export const ReleaseButton: React.FC<Props> = props => {
  const { disabled } = props
  const { trialUid = '', templateUid = '' } = useParams<{
    [templateIdParamName]: string
    [trialIdParamName]: string
  }>()

  const { getTemplate } = useTemplateEntities()
  const template = getTemplate(templateUid)

  const { mediumItems } = useAtomValue(templateDetailAtom)

  const [modalOpen, setModalOpen] = useState(false)

  const toast = useMirohaToast()

  const onClick = () => {
    if (mediumItems.length === 0) {
      toast({ status: 'error', title: 'セクションを追加してください。' })
      return
    }

    const validated = props.onValidate()
    if (
      Object.values(validated).some(
        errorMap => Object.keys(errorMap).length > 0,
      ) ||
      template?.title === ''
    ) {
      toast({
        status: 'error',
        title: '入力に問題があります。再度入力してお試しください。',
      })
      return
    }

    setModalOpen(true)
  }

  useCloseModalByDeps({
    condition: modalOpen === true,
    onClose: () => setModalOpen(false),
    deps: [templateUid],
  })

  const onClose = () => setModalOpen(false)

  return (
    <>
      <Button onClick={onClick} isDisabled={disabled}>
        公開
      </Button>

      {modalOpen && template && (
        <ReleaseTemplateModal
          trialUid={trialUid}
          templateUid={templateUid}
          templateTitle={template.title}
          onClose={onClose}
        />
      )}
    </>
  )
}
